import { createFileRoute } from "@tanstack/react-router";
import PsychiatristVsPsychologistPage from "@/pages/articles/PsychiatristVsPsychologistPage";
export const Route = createFileRoute(
  "/is-it-better-to-see-a-psychiatrist-or-psychologist",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Is It Better to See a Psychiatrist or Psychologist? | Neuro Wellness",
        },
        {
          name: "description",
          content:
            "Understand the differences between psychiatrists (MDs prescribing medication & TMS) and psychologists (PhDs providing psychotherapy), and decide which is.",
        },
        {
          property: "og:title",
          content:
            "Is It Better to See a Psychiatrist or Psychologist? | Neuro Wellness",
        },
        {
          property: "og:description",
          content:
            "Understand the differences between psychiatrists (MDs prescribing medication & TMS) and psychologists (PhDs providing psychotherapy), and decide which is.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/is-it-better-to-see-a-psychiatrist-or-psychologist",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/is-it-better-to-see-a-psychiatrist-or-psychologist",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <PsychiatristVsPsychologistPage />;
}
